import { createSelector } from 'reselect';
export var decimalsByProductId = createSelector(function (state) {
  return state.apexCore.product.products;
}, function (products) {
  return products.reduce(function (decimalPlaces, product) {
    decimalPlaces[product.ProductId] = product.DecimalPlaces;
    return decimalPlaces;
  }, {});
});
export var selectedProductVerificationLevelConfig = createSelector([function (state) {
  return state.user.verificationLevelConfigs;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}], function (configs, selectedProductId) {
  return configs.Products.find(function (_ref) {
    var ProductId = _ref.ProductId;
    return ProductId === selectedProductId;
  });
});